module.exports = __webpack_public_path__ + "img/VIR.d4085cd9.svg";